import { Controller } from '@hotwired/stimulus';

// Fenêtre d'ajout d'un planning : au choix du technicien, la liste des clients
// est remplacée par ses clients affiliés (JSON { customers_list: { nom: id } }) ;
// seule la dernière réponse compte, la liste reste vide si elle échoue.
export default class extends Controller {
    static targets = ['customers'];
    static values = { url: String };

    async load({ target }) {
        if (!target.name?.endsWith('[technician_id]')) return;
        const request = Symbol('customers');
        this.request = request;
        const select = this.customersTarget.querySelector('select');
        select.replaceChildren(new Option('', ''));
        try {
            if (!target.value) return;
            const response = await fetch(`${this.urlValue}?technician_id=${encodeURIComponent(target.value)}`, { headers: { Accept: 'application/json' } });
            const { customers_list: customers } = response.ok ? await response.json() : {};
            if (this.request !== request) return;
            Object.entries(customers || {}).forEach(([name, id]) => select.add(new Option(name, id)));
        } catch (error) {
            // Réponse illisible (session expirée…) : liste laissée vide.
        } finally {
            if (this.request === request) select.dispatchEvent(new CustomEvent('combobox:render', { bubbles: true }));
        }
    }
}
